export default class Validate {
    constructor(form) {
        this.form = $(form);
        this.inputs = this.form.find("input[data-required], select[data-required], textarea[data-required]");
        this.required = this.form.find("[data-required]");
        this.select = this.form.find("[data-select]");
        this.phone = this.form.find("[data-phone]");
        this.radio = this.form.find("[data-radio]");
        this.email = this.form.find("[data-email]");
        this.minlength = this.form.find("[data-minlength]");
        this.fileformat = this.form.find("[data-fileformat]");
        this.submitBtn = this.form.find(".js-submit");
        this.messages = window.validateMessages || {
            required: "Не заполнено поле",
            minlength: "Не менее %min% символов",
            email: "Неправильный формат",
            phone: "Некорректный номер",
            select: "Выберите опцию",
            fileformat: "Недопустимый тип файла",
            filesize: "Файл должен быть до %max% МБ",
            radio: "Выберите опцию"
        };

        /**
            Так как могут быть поля обязательные,
            но ещё не проверенные, приходится вводить
            для них дополнительный класс
        */
        this.form
            .find("[data-required]")
            .not(":checkbox")
            .addClass("_notvalidated");
        // для обязательных чекбоксов только те, что не отмечены по умолчанию
        this.form
            .find(":checkbox[data-required]")
            .not(":checked")
            .addClass("_notvalidated");

        // Для обязательных радио кнопок добавляем класс, если ни одна не выбрана
        this.handleRadioValidation();
        this.handleChange();
    }

    handleRadioValidation() {
        // Проверяем группы радио кнопок
        const radioGroups = {};

        this.form.find("[data-radio][data-required]").each((index, el) => {
            const $radio = $(el);
            const name = $radio.attr("name");

            if (!radioGroups[name]) {
                radioGroups[name] = [];
            }
            radioGroups[name].push($radio);
        });

        // Добавляем класс _notvalidated для групп, где ни одна радио кнопка не выбрана
        Object.keys(radioGroups).forEach(name => {
            const groupRadios = radioGroups[name];
            const isAnyChecked = groupRadios.some($radio => $radio.is(":checked"));

            if (!isAnyChecked) {
                groupRadios.forEach($radio => {
                    $radio.addClass("_notvalidated");
                });
            }
        });
    }

    handleChange() {
        const eventName = App.ie ? "change blur" : "change";

        this.inputs.on(eventName, (e) => {
            const $input = $(e.target);
            this.validateField($input);

            this.maybeShowRadioErrors();

            // Считаем ошибки
            this.calculateErrors();
        });

        // Обработка изменений для радио кнопок
        this.form.find("[data-radio]").on("change", (e) => {
            const $radio = $(e.target);
            const name = $radio.attr("name");

            // Валидируем все радио кнопки в группе
            this.form.find(`[name="${name}"][data-radio]`).each((index, el) => {
                this.validateField($(el));
            });

            // Считаем ошибки
            this.calculateErrors();
        });
    }

    // Подсветить незаполненные обязательные радио-группы ошибкой,
    // но только если все остальные обязательные поля уже валидны.
    // До этого момента — тишина, чтобы пользователь не видел ошибку
    // на радио раньше, чем дошёл до него.
    maybeShowRadioErrors() {
        const $nonRadioRequired = this.form
            .find("[data-required]")
            .not("[data-radio]");
        const hasUnresolvedNonRadio = $nonRadioRequired
            .filter("._error, ._notvalidated")
            .length > 0;

        if (hasUnresolvedNonRadio) return;

        const seenGroups = new Set();
        this.form.find("[data-radio][data-required]").each((index, el) => {
            const name = $(el).attr("name");
            if (seenGroups.has(name)) return;
            seenGroups.add(name);

            this.validateRequiredRadio($(el));
            this.form
                .find(`[name="${name}"][data-radio]`)
                .removeClass("_notvalidated");
        });
    }

    validateField($input) {
        // Запускаем проверки
        if ($input.is(":checkbox[data-required]")) {
            this.validateRequiredCheckbox($input);
        } else if ($input.is(":radio[data-required]")) {
            this.validateRequiredRadio($input);
        } else if ($input.is("[data-required]")) {
            this.validateRequired($input);
        }

        if ($input.is("[type=email]") || $input.is("[data-email]")) {
            this.validateEmail($input);
        }

        if ($input.is("[data-minlength]")) {
            this.validateMinLength($input);
        }

        if ($input.is("[data-fileformat]")) {
            this.validateFileFormat($input);
        }

        /**
            Теперь поле либо валидно, либо у него
            есть класс _error, и ложной разблокировки
            кнопки сабмита не будет
        */
        $input.removeClass("_notvalidated");
    }

    validateRequired($input) {
        // Проверяем обязательные поля

        const $label = $input.parents(".js-input-wrap").find("[data-label]");
        const val = $input.val().replace(/\s/g, "");
        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length > 0) {
            $input.removeClass("_error");
            $label.text("");

            if ($input.hasClass("js-phone") && $input.parents(".iti").is('._error')) {
                $input.addClass("_error");
                $label.text(this.messages.phone);
            }
        } else {
            if ($input.hasClass("js-select")) {
                $input.addClass("_error");
                $label.text(this.messages.select);
            } else if ($input.hasClass("js-phone")) {
                $input.addClass("_error");
                $label.text(this.messages.phone);
            } else {
                $input.addClass("_error");
                $label.text(this.messages.required);
            }
        }
    }

    validateRequiredEmpty($input) {
        // Проверяем обязательные поля, не добавляя класс _error
        const val = $input.val().replace(/\s/g, "");

        if (val.length > 0) {
            $input.removeClass("_empty");
        } else {
            $input.addClass("_empty");
        }
    }

    validateRequiredRadio($input) {
        // Проверяем обязательные радио кнопки
        const name = $input.attr("name");
        const $groupRadios = this.form.find(`[name="${name}"][data-radio]`);
        const $label = $input.closest('.js-checkbox-wrap').find("[data-label]");
        // Проверяем, есть ли выбранная радио кнопка в группе
        const isAnyChecked = $groupRadios.is(":checked");

        if (isAnyChecked) {
            // Убираем ошибки у всех радио кнопок группы
            $groupRadios.removeClass("_error");
            $label.text("");
        } else {
            // Добавляем ошибки всем радио кнопкам группы
            $groupRadios.addClass("_error");
            $label.text(this.messages.radio);
        }
    }

    validateRequiredCheckboxEmpty($input) {
        // Проверяем обязательные чекбоксы, не добавляя класс _error
        if ($input.is(":checked")) {
            $input.removeClass("_empty");
        } else {
            $input.addClass("_empty");
        }
    }

    validateRequiredCheckbox($input) {
        // Проверяем обязательные чекбоксы
        const $label = $input.parent().siblings("[data-label]");

        if ($input.is(":checked")) {
            $input.removeClass("_error");
            $label.text("");
        } else {
            $input.addClass("_error");
            $label.text(this.messages.required);
        }
    }

    validateRequiredRadioEmpty($input) {
        // Проверяем обязательные радио кнопки, не добавляя класс _error
        const name = $input.attr("name");
        const $groupRadios = this.form.find(`[name="${name}"][data-radio]`);
        const isAnyChecked = $groupRadios.is(":checked");

        if (isAnyChecked) {
            $groupRadios.removeClass("_empty");
        } else {
            $groupRadios.addClass("_empty");
        }
    }

    validateMinLength($input) {
        // Проверяем минимальное количество символов

        const $label = $input.siblings("[data-label]");
        const min = $input.data("minlength");
        const val = $.trim($input.val());

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length >= min) {
            // Достаточно символов

            $input.removeClass("_error");
            $label.text("");
        } else if (val.length > 0) {
            // Недостаточно символов

            const message = this.messages.minlength.replace("%min%", min);

            $input.addClass("_error");
            $label.text(message);
        } else if (val.length == 0 && $input.is(":not([data-required])")) {
            // Поле пустое и необязательное

            /**
                Если оно обязательное, в этом случае за него
                будет отвечать validateRequired()
            */

            $input.removeClass("_error");
            $label.text("");
        }
    }

    validateEmail($input) {
        // Проверяем email

        const $label = $input.siblings("[data-label]");
        const val = $input.val().replace(/\s/g, "");

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length) return;

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (
            /^[a-z0-9](\.?[a-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i.test(
                val
            )
        ) {
            $input.removeClass("_error");
            $label.text("");
        } else {
            $input.addClass("_error");
            $label.text(this.messages.email);
        }

        // Проверка на корпоративную почту работает для всех локалей, кроме Саудовской Аравии

        const locale = (document.documentElement.lang || "").toLowerCase();
        const isSaLocale = locale.startsWith("sa") || locale.startsWith("ksa");

        if (isSaLocale === false && $input.hasClass('webinar-email') === false) {
            const disallowedDomains = [
                'gmail',
                'yahoo',
                'hotmail',
                'mail',
                'list',
                'icloud',
                'outlook',
                'msn'
            ];

            const emailDomain = val.split('@')[1] || '';
            const fillEmailDomain = emailDomain.split('.')[0];
            if (disallowedDomains.includes(fillEmailDomain) === true) {
                $label.text('Please use your corporate email address');
                $input.addClass("_error");
            }
        }
    }

    validateFileFormat($input) {
        // Проверяем расширение файла

        const $label = $input.siblings("[data-label]");
        const accept = $input.attr("accept").split(",");
        const val = $input.val();

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length && $input.is("[data-required]")) {
            return;
        } else if (!val.length) {
            $input.removeClass("_error");
            $label.text("");
            return;
        }

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        let ext = "." + val.split(".").pop();
        ext = ext.toLowerCase();

        if ($.inArray(ext, accept) > -1) {
            $input.removeClass("_error");
            $label.text("");

            /**
                Если формат файла ОК, после этого
                проверяем размер файла
            */
            if ($input.is("[data-filesize]")) {
                this.validateFileSize($input);
            }
        } else {
            $input.addClass("_error");
            $label.text(this.messages.fileformat);
        }
    }

    validateFileSize($input) {
        // Проверяем размер загруженного файла

        const $label = $input.siblings("[data-label]");
        const max = +$input.data("filesize");

        if ($input[0].files.length) {
            const size = $input[0].files[0].size / 1024 / 1024;

            if (size > max) {
                const message = this.messages.filesize.replace("%max%", max);
                $input.addClass("_error");
                $label.text(message);
            }
        }
    }

    // Проверить все ошибки формы
    validateAllFields() {
        this.inputs.each((index, el) => {
            let $currInput = $(el);

            this.validateField($currInput);
        });

        // Проверяем радио кнопки отдельно
        const radioGroups = {};
        this.form.find("[data-radio][data-required]").each((index, el) => {
            const $radio = $(el);
            const name = $radio.attr("name");

            if (!radioGroups[name]) {
                radioGroups[name] = $radio;
            }
        });

        Object.keys(radioGroups).forEach(name => {
            this.validateField(radioGroups[name]);
        });

        return this.returnErrorsCount() === 0;
    }

    // Проверить все поля формы на заполненность
    validateAllFieldsNotEmpty() {
        this.inputs.each((index, el) => {
            let $currInput = $(el);
            if ($currInput.is('[type="checkbox"]'))  {
                this.validateRequiredCheckboxEmpty($currInput);
            } else if ($currInput.is('[type="radio"]')) {
                this.validateRequiredRadioEmpty($currInput);
            } else {
                this.validateRequiredEmpty($currInput);
            }
        });

        return this.form.find("._notvalidated, ._empty").length === 0;
    }

    returnErrorsCount() {
        return this.form.find("._error, ._notvalidated").length;
    }

    calculateErrors() {
        // Подводим итоги проверок

        const errors = this.form.find("._error, ._notvalidated").length;

        /**
            Считаем ошибки в форме,
            и блокируем или разблокируем
            кнопку сабмита
        */
        if (errors > 0) {
            this.submitBtn.attr("disabled", true);
        } else {
            this.submitBtn.removeAttr("disabled");
        }
    }
}
